import React from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const ExperienceSection = () => {
  return (
    <section className="py-20 md:py-28 bg-white border-t" style={{ fontFamily: "'DM Sans', sans-serif", borderTopColor: "#BAB7C2", borderTopWidth: "1px" }}>
      <div className="max-w-[1300px] mx-auto px-6 md:px-12 lg:px-24">
        {/* Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center text-[#1a1a2e] mb-4 leading-tight"
          style={{ fontSize: "clamp(38px, 5vw, 56px)", fontWeight: 800 }}
        >
          Experience Elevante in Action
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          className="text-center text-gray-500 text-[16px] md:text-[17px] max-w-[720px] mx-auto mb-16 leading-relaxed"
        >
          A quick walkthrough of how Elevante enables hands-on AI learning for everyone
        </motion.p>

        {/* Screenshot with decorations */}
        <div className="max-w-[1000px] mx-auto relative">
          {/* Purple sparkle decoration — top-left, larger and offset from the dashboard panel */}
          <img
            src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/xigsbv3g_Sketch-annotation-element-stroke-abstract--highlight-bling-line-2.png"
            alt=""
            aria-hidden="true"
            className="hidden sm:block absolute -top-12 -left-10 sm:-left-12 md:-left-14 w-16 sm:w-20 md:w-24 h-auto z-10 select-none pointer-events-none"
          />

          {/* Screenshot with bottom fade */}
          <div className="rounded-3xl overflow-hidden border-[3px] border-gray-300 shadow-2xl bg-white relative">
            <img 
              src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/3odcwdgc_image.png"
              alt="Elevante Platform Demo"
              className="w-full h-auto"
            />
            
            {/* White gradient fade at bottom */}
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white via-white/60 to-transparent pointer-events-none" />
          </div>

          {/* Watch our product button - positioned at bottom center of screenshot */}
          <button className="group absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2 sm:gap-3 bg-white px-3 sm:px-6 py-2 sm:py-3 rounded-full shadow-lg z-10 cursor-pointer transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-0.5 hover:bg-gray-50">
            <div className="w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-[#8B5CF6] border-2 border-black flex items-center justify-center transition-transform duration-300 ease-out group-hover:scale-110">
              <Play className="w-3 h-3 sm:w-4 sm:h-4 text-white ml-0.5" fill="white" stroke="black" strokeWidth={2} />
            </div>
            <span className="text-[13px] sm:text-[18px] font-semibold text-[#1a1a2e] whitespace-nowrap">Watch our product</span>
          </button>

          {/* Curly arrow + "just 10mins" handwritten text — small, just below the play button */}
          <div className="absolute bottom-[-60px] sm:bottom-[-66px] left-1/2 -translate-x-[110px] sm:-translate-x-[120px] flex flex-col items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/9nicrv5j_Vector.png"
              alt=""
              aria-hidden="true"
              className="w-4 sm:w-5 h-auto select-none pointer-events-none"
            />
            <span
              className="text-[15px] sm:text-[17px] text-[#6B7280] whitespace-nowrap mt-1"
              style={{
                fontFamily: "'Kalam', cursive",
                fontWeight: 700,
                fontStyle: "italic",
                transform: "rotate(-6deg)",
              }}
            >
              just 10mins
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
